import { AttackerApi, AttackerCategoryApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

export const attackerApi = new AttackerApi(BrmApiClient.instance);
export const attackerCategoryApi = new AttackerCategoryApi(BrmApiClient.instance);
